import { bulkConfirmAdapter } from './adapters/bulkConfirmAdapter';
import { jobsAdapter } from './adapters/jobsAdapter';
import { jobsApi } from './jobsApi';
import { IAverageRating } from './types/averageRateTypes';
import { IBulkConfirmPayload } from './types/bulkConfirmTypes';
import { IGetJobsParams, IJob } from './types/jobsTypes';

async function getJobs(params: IGetJobsParams): Promise<IJob[]> {
  const jobsAPI = await jobsApi.getJobs(params);
  return jobsAPI.map(jobsAdapter.toJob);
}

async function bulkConfirmJobs(params: IBulkConfirmPayload): Promise<string[]> {
  const request = bulkConfirmAdapter.toBulkConfirmRequest(params);
  return await jobsApi.bulkConfirmJobs(request);
}

async function getAverageRate(officeId: string): Promise<IAverageRating> {
  return jobsApi.getAverageRate(officeId);
}

export const jobsService = {
  getJobs,
  bulkConfirmJobs,
  getAverageRate,
};
